const IMMEDIATE_FLAG_KEY = 'qumashi:celebrationImmediate';
const LAST_BLOCKING_KEY = 'qumashi:celebrationLastBlocking';
const DEFERRED_KEY = 'qumashi:deferredCelebrations';
const BLOCKING_COOLDOWN_MS = 5 * 60 * 1000;

export function markCelebrationImmediate() {
  try {
    sessionStorage.setItem(IMMEDIATE_FLAG_KEY, String(Date.now()));
  } catch {
    // ignore
  }
}

export function consumeCelebrationImmediate(): boolean {
  try {
    const raw = sessionStorage.getItem(IMMEDIATE_FLAG_KEY);
    sessionStorage.removeItem(IMMEDIATE_FLAG_KEY);
    if (!raw) return false;
    const ts = Number(raw);
    if (!Number.isFinite(ts)) return false;
    return Date.now() - ts < 2 * 60 * 1000;
  } catch {
    return false;
  }
}

export function canShowBlockingCelebration(): boolean {
  try {
    const raw = sessionStorage.getItem(LAST_BLOCKING_KEY);
    if (!raw) return true;
    const ts = Number(raw);
    if (!Number.isFinite(ts)) return true;
    return Date.now() - ts >= BLOCKING_COOLDOWN_MS;
  } catch {
    return true;
  }
}

export function recordBlockingCelebrationShown() {
  try {
    sessionStorage.setItem(LAST_BLOCKING_KEY, String(Date.now()));
  } catch {
    // ignore
  }
}

export function readDeferredCelebrationIds(persona: string): string[] {
  try {
    const raw = sessionStorage.getItem(DEFERRED_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as Record<string, string[]>;
    return parsed[persona] ?? [];
  } catch {
    return [];
  }
}

export function writeDeferredCelebrationIds(persona: string, ids: string[]) {
  try {
    const raw = sessionStorage.getItem(DEFERRED_KEY);
    const parsed = raw ? (JSON.parse(raw) as Record<string, string[]>) : {};
    if (ids.length === 0) {
      delete parsed[persona];
    } else {
      parsed[persona] = ids;
    }
    if (Object.keys(parsed).length === 0) {
      sessionStorage.removeItem(DEFERRED_KEY);
    } else {
      sessionStorage.setItem(DEFERRED_KEY, JSON.stringify(parsed));
    }
  } catch {
    // ignore
  }
}

export function addDeferredCelebrationIds(persona: string, ids: string[]) {
  const existing = new Set(readDeferredCelebrationIds(persona));
  for (const id of ids) existing.add(id);
  writeDeferredCelebrationIds(persona, [...existing]);
}

export function removeDeferredCelebrationId(persona: string, id: string) {
  writeDeferredCelebrationIds(
    persona,
    readDeferredCelebrationIds(persona).filter((d) => d !== id),
  );
}

export function clearDeferredCelebrations(persona: string) {
  writeDeferredCelebrationIds(persona, []);
}
